import { Sorter } from '@/modules/common/components/sorter';
import { Dropdown } from './components/dropdown';
import styles from './index.module.sass';
import { TagFilter } from './components/tag-filter';
import { useEffect, useState } from 'react';
import {
  $agriculture,
  loadAgricultureFx,
} from '@/modules/agriculture/store/agriculture.store';
import { useStore } from 'effector-react';
import { $localSort, setSortLocalState } from '../../store/offer-page.store';

export const FiltersBar = () => {
  const cultures = useStore($agriculture);

  const sort = useStore($localSort);
  const setSort = setSortLocalState;

  useEffect(() => {
    loadAgricultureFx();
  }, []);

  useEffect(() => {
    setSort({
      ...sort,
      cultures: cultures.map((item) => ({
        label: item.name.toLocaleLowerCase(),
        value: item.id,
        active: false,
      })) as any,
    });
  }, [cultures]);

  return (
    <div className={styles.root}>
      <div className={styles.topBar}>
        <Dropdown
          title="культура"
          placeholder="все культуры"
          options={sort.cultures}
          onSelectOption={(item) =>
            setSort({
              ...sort,
              cultures: sort.cultures.map((subItem) =>
                item.value === subItem.value
                  ? { ...subItem, active: !subItem.active }
                  : subItem,
              ),
            })
          }
          multipleSelect={true}
        />
        <Dropdown
          title="состояние"
          placeholder="все состояния"
          options={sort.active}
          onSelectOption={(item) =>
            setSort({
              ...sort,
              active: sort.active.map((subItem) =>
                item.value === subItem.value
                  ? { ...subItem, active: !subItem.active }
                  : subItem,
              ),
            })
          }
          multipleSelect={true}
        />
        <Dropdown
          title="действия"
          placeholder="все действия"
          options={sort.action}
          onSelectOption={(item) =>
            setSort({
              ...sort,
              action: sort.action.map((subItem) =>
                item.value === subItem.value
                  ? { ...subItem, active: !subItem.active }
                  : subItem,
              ),
            })
          }
          multipleSelect={true}
        />
        <Sorter
          className={styles.sorter}
          sortOption={sort.options}
          setSortOption={(val) => setSort({ ...sort, options: val })}
          orderBy={sort.order as 'asc' | 'desc'}
          setOrderBy={(val) => setSort({ ...sort, order: val })}
        />
      </div>
      <div className={styles.bottomBar}>
        {sort.cultures.map(
          (item, i) =>
            item.active && (
              <TagFilter
                key={i}
                label={item.label}
                value={item.value}
                onCancel={() =>
                  setSort({
                    ...sort,
                    cultures: sort.cultures.map((sItem) =>
                      sItem.value === item.value ? { ...sItem, active: false } : sItem,
                    ),
                  })
                }
              />
            ),
        )}

        {sort.active.map(
          (item, i) =>
            item.active && (
              <TagFilter
                key={i}
                label={item.label}
                value={item.value}
                onCancel={() =>
                  setSort({
                    ...sort,
                    active: sort.active.map((sItem) =>
                      sItem.value === item.value ? { ...sItem, active: false } : sItem,
                    ),
                  })
                }
              />
            ),
        )}
        {sort.action.map(
          (item, i) =>
            item.active && (
              <TagFilter
                key={i}
                label={item.label}
                value={item.value}
                onCancel={() =>
                  setSort({
                    ...sort,
                    action: sort.action.map((sItem) =>
                      sItem.value === item.value ? { ...sItem, active: false } : sItem,
                    ),
                  })
                }
              />
            ),
        )}
      </div>
    </div>
  );
};
